import { ORIGIN_PATTERNS } from '../modules/origin'
import { getQueryParameterByName } from '../utils/urls'
import { OriginKeyword } from '../types/register.type'
import { ApplicationVersion } from '../types/version.type'
import { payrollValidCountries } from './product'

type OriginHandler = (url: string, country: ApplicationVersion) => OriginKeyword | null

const testURL = (url: string, regex: RegExp) => regex.test(url)
const urlArray = window.location.pathname.split('/')

const isPosLanding = (url: string) =>
  ORIGIN_PATTERNS.POS.some(regex => regex.test(url)) ||
  ['pos', 'tpv', 'punto-venta'].some(path => urlArray.includes(path))

const isPayrollLanding = (url: string) =>
  testURL(url, ORIGIN_PATTERNS.NOMINA) || urlArray.includes('nomina')

const isResicoLanding = (url: string) =>
  testURL(url, ORIGIN_PATTERNS.RESICO) || urlArray.includes('resico')

// Origin dictionary
const originDictionary: Partial<Record<OriginKeyword, OriginHandler>> = {
  educacion: () => (urlArray.includes('educacion') ? 'educacion' : null),

  'pos-boutiques': url => (testURL(url, ORIGIN_PATTERNS.POS_BOUTIQUES) ? 'pos-boutiques' : null),

  'alegra-pos': url => (isPosLanding(url) ? 'alegra-pos' : null),

  'partner-pos-wompi': (url, country) =>
    testURL(url, ORIGIN_PATTERNS.POS_WOMPI_COLOMBIA)
      ? country === 'colombia'
        ? 'partner-pos-wompi'
        : 'alegra-pos'
      : null,

  'alegra-only-invoicing': (url, country) => {
    const allowedCountries: ApplicationVersion[] = [
      'colombia',
      'peru',
      'republicaDominicana',
      'argentina',
      'costaRica',
      'panama',
      'mexico',
      'spain',
      'venezuela',
    ]

    const isValidSource =
      testURL(url, ORIGIN_PATTERNS.SOLO_FE) ||
      getQueryParameterByName('alegra_source') === 'planes-solo-facturacion'

    return isValidSource
      ? allowedCountries.includes(country)
        ? 'alegra-only-invoicing'
        : 'alegra-api'
      : null
  },

  'alegra-fe': url => (testURL(url, ORIGIN_PATTERNS.FE) ? 'alegra-fe' : null),

  'alegra-invoicing': (url, country) =>
    testURL(url, ORIGIN_PATTERNS.FACTURACION)
      ? country === 'costaRica'
        ? 'alegra-invoicing'
        : 'alegra-api'
      : null,

  'alegra-resico': url => (isResicoLanding(url) ? 'alegra-resico' : null),

  'alegra-payroll': (url, country) => {
    const isValidSource = isPayrollLanding(url)

    return isValidSource
      ? payrollValidCountries.includes(country)
        ? 'alegra-payroll'
        : 'alegra-api'
      : null
  },
}

export { originDictionary }
